import React from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/zeroVisitsSagas";

const CustomDateRanges = () => {
  const dispatch = useDispatch();
  const { rangeOptions, selectedRangeOption } = useSelector((state) => state.zeroVisits);

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};
export default CustomDateRanges;
